export default __webpack_public_path__ + "static/gallery-art-fashion-dcb7de8b2725ef61157c4831b351a8a3.jpg";